import React, { FunctionComponent } from 'react';
import { Redirect } from 'react-router-dom';
import { useAccount } from '../../hooks/useAccount';
import { useBriefsOverview } from '../../hooks/useBriefs';
import { useFeatureFlags } from '../../hooks/useFeatureFlag';
import { useProducts } from '../../hooks/useProducts';
import { getSession } from '../../services/authentication';
import LoadingSpinner from '../loading-spinner/LoadingSpinner';
import { Button, NonIdealState } from '../ui';
import DashboardAppRoutes from '../Routes/DashboardAppRoutes';

const DashboardApp: FunctionComponent = () => {
  const { account, loading: isLoadingAccount, error, refetch } = useAccount();

  // Warm the caches at dashboard mount, mirroring the legacy prefetch
  // behavior so downstream consumers (pricing, paywall, flags, briefs list)
  // render without a loading state.
  useFeatureFlags();
  useProducts();
  useBriefsOverview();

  if (isLoadingAccount) {
    return <LoadingSpinner />;
  }

  if (!account) {
    // A transient viewer-query failure must not bounce a signed-in user to
    // the sign-in page (revoked sessions are handled separately by the
    // 'Access denied' funnel in useServiceErrorHandler).
    if (error && getSession()) {
      return (
        <div className="flex h-screen items-center justify-center">
          <NonIdealState
            icon="error"
            title="Something went wrong"
            description="We couldn't load your account. Please check your connection and try again."
            action={
              <Button variant="purple" className="mt-4" onClick={() => refetch()}>
                Retry
              </Button>
            }
          />
        </div>
      );
    }

    return <Redirect to={'/users/signin'} />;
  }

  return (
    <>
      <DashboardAppRoutes />
    </>
  );
};

export default DashboardApp;
